var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "504.849 173.291 20 20",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 514.849 193.291 C 509.331 193.291 504.849 188.809 504.849 183.291 C 504.849 177.773 509.331 173.291 514.849 173.291 C 520.367 173.291 524.849 177.773 524.849 183.291 C 524.849 188.809 520.367 193.291 514.849 193.291 Z M 514.849 174.72 C 510.125 174.72 506.277 178.567 506.277 183.291 C 506.277 188.015 510.125 191.862 514.849 191.862 C 519.573 191.862 523.421 188.015 523.421 183.291 C 523.421 178.567 519.573 174.72 514.849 174.72 Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 519.849 184.809 L 514.135 184.809 C 513.742 184.809 513.421 184.487 513.421 184.095 L 513.421 178.38 C 513.421 177.987 513.742 177.666 514.135 177.666 C 514.528 177.666 514.849 177.987 514.849 178.38 L 514.849 183.38 L 519.849 183.38 C 520.242 183.38 520.563 183.702 520.563 184.095 C 520.563 184.487 520.242 184.809 519.849 184.809 Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a836233ed5a1e1c27839c9971f31c9c9.svg";
export { ForwardRef as ReactComponent };